import { useEffect, useState } from "react";
import LoaderWrapper from "../../../../widgets/loaderWrapper/LoaderWrapper";
import TableWidget from "../../../../widgets/table/tableWidget/TableWidget";
import { defineCustomTableColumns, lazyFetchCustomTableData, fetchCustomTableObjectTypeDataCount, prepareQueryArgsForCustomTableFetch, saveCustomTableStateWebStorage } from "../customTableObjectType/customTableObjectTypeFunctions";
import { useParams } from "react-router-dom";
import { getItemWebStorage } from "../../../../features/webStorageSaver";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { authorizeToCustomRest } from "../../../../features/customAuth/customAuth";
import { configureTableLazyState, defineTableFilters, TableEvents, tableStateModifyHandle } from "../../../../widgets/table/tableFeatures/tableFunctions";
import { prepareTableData } from "../../../../features/dataFormatFunctions/dataFormatter";
import { getBasicTablePaginator } from "../../../../widgets/table/tableFeatures/tableTemplates/tablePaginatorTemplates";
import ContentHeader from "../../../../widgets/contentHeader/ContentHeader";
import { useDispatch } from "react-redux";
import { showToastMessage } from "../../../../stateManagement/reducers";
import ToastMessageContainer from "../../../../widgets/toastMessageContainer/ToastMessageContainer";

export default function CustomNestedTable() {
    const { id, objectType, entityId, nestedObjectType }: any = useParams()
    const dispatch = useDispatch()
    const [name, setName] = useState<any>(null)
    const [tableState, setTableState] = useState<any>(null)
    const [tableDataIsLoading, setTableDataIsLoading] = useState<boolean>(true)
    const [isErrorTableStructure, setIsErrorTableStructure] = useState<boolean>(false)
    const [isErrorTableData, setIsErrorTableData] = useState<boolean>(false)
    const [tableData, setTableData] = useState<any>([])
    const [dataCount, setDataCount] = useState<number>(0)
    const [columns, setColumns] = useState<any>(null)
    const [paginator, setPaginator] = useState<any>({})
    const [paginatorPageInputTooltip, setPaginatorPageInputTooltip] = useState<any>('Введите номер страницы.')
    const restAuthToken = useAppSelector(state => state.customAuth.customAuthToken)
    const currentConfig = getItemWebStorage('currentConfig')
    const { tableAdditionalItems } = currentConfig
    const tableAdditionalItem = tableAdditionalItems.find((item: any) => item?.id === id)

    useEffect(() => {
        const { nestedTable, restAuthRequestOptions } = tableAdditionalItem ?? {}
        const { title } = nestedTable ?? {}
        if (restAuthRequestOptions && !restAuthToken) {
            authorizeToCustomRest(restAuthRequestOptions)
        }
        title ? setName(`Таблица «${title}»`) : setName('Таблица «...»')
    }, [objectType])

    async function defineTableColumns() {
        const { nestedTable, restAuthRequestOptions, api } = tableAdditionalItem ?? {}
        const { structure } = nestedTable ?? {}
        if (structure) {
            let columnsStructure: any = structure?.columns
            let columns = await defineCustomTableColumns(columnsStructure, api, restAuthToken, restAuthRequestOptions)
            let filters = defineTableFilters(columns)
            setColumns(columns)
            setTableState(getItemWebStorage("customTablesState")?.[nestedObjectType] ?? configureTableLazyState({ filters }))
        }
        else {
            setIsErrorTableStructure(true)
        }
    }

    async function getTableValueAndCount() {
        setTableDataIsLoading(true)
        const { nestedTable, restAuthRequestOptions, api } = tableAdditionalItem ?? {}
        const { nestedData: nestedTableDataApi, nestedDataCount: nestedTableDataCountApi } = api ?? {}
        const { propertyForEntityIdFilter } = nestedTable ?? {}
        const { sort, filter, offset }: any = prepareQueryArgsForCustomTableFetch(tableState, columns)
        const nestedTableFilter = {
            property: propertyForEntityIdFilter,
            operator: "=",
            value: entityId
        }
        filter.conditions.push(nestedTableFilter)
        let { tableData, error }: any = await lazyFetchCustomTableData(nestedTableDataApi, restAuthToken, 100, offset, sort, filter, restAuthRequestOptions)
        if (error) {
            setIsErrorTableData(true)
        }
        tableData = prepareTableData(tableData, columns)
        setTableData(tableData)
        let dataCount = await fetchCustomTableObjectTypeDataCount(nestedTableDataCountApi, restAuthToken, filter, restAuthRequestOptions)
        setDataCount(dataCount)
        setTableDataIsLoading(false)
    }

    useEffect(() => {
        const paginatorTemplate = getBasicTablePaginator(paginatorPageInputTooltip, setPaginatorPageInputTooltip, tableState, setTableState, dataCount, objectType)
        setPaginator(paginatorTemplate)
    }, [dataCount, tableState, paginatorPageInputTooltip])

    useEffect(() => {
        if (restAuthToken) {
            defineTableColumns()
        }
    }, [restAuthToken])

    useEffect(() => {
        if (restAuthToken && columns) {
            getTableValueAndCount()
        }
    }, [restAuthToken, columns, tableState])

    const onSort = (state: any) => tableStateModifyHandle(state, TableEvents.sort, setTableState, nestedObjectType)
    const onPage = (state: any) => tableStateModifyHandle(state, TableEvents.page, setTableState, nestedObjectType)
    const onFilter = (state: any) => tableStateModifyHandle(state, TableEvents.filter, setTableState, nestedObjectType)

    useEffect(() => {
        if (isErrorTableStructure || isErrorTableData) {
            dispatch(showToastMessage({ messageText: "Ошибка загрузки таблицы", messageType: "error" }))
        }
    }, [isErrorTableStructure, isErrorTableData])

    return (
        <>
            <ContentHeader title={name} />
            <div className="table-widget-with-toast with-content-header">
                <ToastMessageContainer/>
                <LoaderWrapper isLoading={tableDataIsLoading} >
                    <TableWidget
                        tableValue={tableData}
                        tableState={tableState}
                        columns={columns}
                        onRowSelect={() => { }}
                        dataCount={dataCount}
                        paginatorTemplate={paginator}
                        pageSize={100}
                        onPage={onPage}
                        onSort={onSort}
                        onFilter={onFilter}
                        type="custom"
                        isLazy={true}
                    />
                </LoaderWrapper>
            </div >
        </>
    )
}
